export const ENTRY_INTAKE_UPDATE_EVENT = 'honeyshow:entry-intake-update'
